import React from "react";

interface CoachStats {
  totalActiveUsers: number;
  totalDepartments: number;
  totalTeams: number;
}

interface CoachStatsBarProps {
  stats: CoachStats;
  loading?: boolean;
}

const StatCard: React.FC<{
  icon: React.ReactNode;
  label: string;
  value: number;
  accent: string;
  loading?: boolean;
}> = ({ icon, label, value, accent, loading }) => (
  <div
    className="flex-1 min-w-0 bg-white rounded-2xl px-5 py-10 flex items-center gap-4"
    style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}
  >
    <div
      className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
      style={{ background: accent + "18" }}
    >
      <span style={{ color: accent }}>{icon}</span>
    </div>
    <div className="min-w-0">
      <p
        className="text-[11px] font-semibold uppercase tracking-wider mb-0.5"
        style={{ color: "#9ba5b4", fontFamily: "var(--font-primary)" }}
      >
        {label}
      </p>
      {loading ? (
        <div className="h-7 w-10 bg-gray-100 rounded animate-pulse" />
      ) : (
        <p
          className="text-[28px] font-bold leading-none"
          style={{ color: "#26295e", fontFamily: "var(--font-primary)" }}
        >
          {value}
        </p>
      )}
    </div>
  </div>
);

const CoachStatsBar: React.FC<CoachStatsBarProps> = ({ stats, loading }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      <StatCard
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        }
        label="Active Users"
        value={stats.totalActiveUsers}
        accent="#0067ff"
        loading={loading}
      />
      <StatCard
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
          </svg>
        }
        label="Departments"
        value={stats.totalDepartments}
        accent="#8b5cf6"
        loading={loading}
      />
      <StatCard
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
        }
        label="Total Teams"
        value={stats.totalTeams}
        accent="#10b981"
        loading={loading}
      />
    </div>
  );
};

export default CoachStatsBar;
